import React from "react";

const Social = () => {
  return (
    <>
      <div className="home_social" style={{margin:"auto 0"}}>
        <a href="https://www.instagram.com/mohammad_kaif_001/" className="home_social-icon" target="_blank">
        <i class="fa-brands fa-instagram"></i>
        </a>
        <a href="https://twitter.com/_kaif_001" className="home_social-icon" target="_blank">
        <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="https://github.com/Mdkaif001" className="home_social-icon" target="_blank">
        <i class="fa-brands fa-github"></i>  
        </a>
      </div>
    </>
  );
};

export default Social;
